export const IS_ADWILE = window.location.href.includes("adwile");
